import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsOptimizeWorkTypeSchemeRoute: InvariantJiraRoute = {
	name: 'global-settings-optimize-work-type-scheme-view',
	path: '/jira/settings/issues/issue-type-schemes/:workTypeSchemeId/optimize',
};
